import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconBottomArrow = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="60"
      height="61"
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      className="yfm-icon-bottom-arrow"
      {...omit(props, ["className"])}
    >
      <circle cx="30" cy="30" r="30" fill="white" />
      <circle cx="30" cy="31" r="30" fill="#587CF4" fillOpacity="0.1" />
      <circle cx="30" cy="30" r="22" fill="#51F1F6" />
      <path
        d="M39.5244 25.2379L30.7077 34.0546C30.3172 34.4451 29.684 34.4451 29.2935 34.0546L20.4768 25.2379"
        stroke="#17215C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
);

IconBottomArrow.displayName = "IconBottomArrow";

export default IconBottomArrow;
